import {
  INFO_KEY,
  SESSION_KEY,
  TOKEN_KEY,
  USER_KEY,
  clearSession,
  parseSession,
  persistSession,
  readStoredSession,
  reconcileLegacySession,
} from './session-storage';

// Останній токен свого акаунта, який ця вкладка вже використала, разом із власником.
// Потрібен, коли сховище зайняв інший акаунт: store може тримати перший токен вкладки,
// а він після повторного входу в іншій вкладці вже недійсний (єдина сесія). Власник
// звіряється перед використанням: якщо вкладка тим часом сама увійшла в інший акаунт,
// кеш попереднього акаунта не підходить.
let lastOwn = null;

// Vuex store прив'язується з main.js (Auth.bindStore), а не імпортується тут: прямий
// імпорт @/store із shared/lib/auth замикав цикл App.vue → mixin → entities/insurance →
// http-client → auth → store, і store читав state ще не ініціалізованих модулів
// entities/insurance. До прив'язки вкладка вважається такою, що не увійшла.
let store = null;

/**
 * Акаунт, під яким працює ця вкладка (state store), null до входу.
 */
const tabUserKey = () => (store && store.getters.KEY_USER) || null;

/**
 * Сесія зі сховища належить акаунту цієї вкладки. Розбіжність означає, що в іншій
 * вкладці виконано вхід в інший акаунт (наприклад, за посиланням з Telegram-бота без
 * виходу): тоді чужий токен брати не можна, інакше запити з форм цієї вкладки підуть
 * від імені іншого користувача, поки store і UI ще показують попереднього.
 */
const isSessionCurrent = (session, tab) => {
  return !session || (!!tab && session.keyUser === tab);
};

const Auth = {
  /**
   * @param {import('vuex').Store} vuexStore
   */
  bindStore: (vuexStore) => {
    store = vuexStore;
  },

  INFO_KEY,
  SESSION_KEY,
  TOKEN_KEY,
  USER_KEY,

  parseSession,
  readStoredSession,
  reconcileLegacySession,
  persistSession: (session) => {
    persistSession(session);
    // Вхід у цій вкладці оновлює кеш ще до першого захищеного запиту.
    lastOwn = { keyUser: session.keyUser, token: session.token };
  },
  clearSession: () => {
    lastOwn = null;
    clearSession();
  },
  tabUserKey,

  storedUserKey: () => {
    const session = readStoredSession();
    return session ? session.keyUser : null;
  },

  isStoredAccountCurrent: () => isSessionCurrent(readStoredSession(), tabUserKey()),

  /**
   * Токен для запитів цієї вкладки: свіжий зі сховища, якщо воно належить тому ж
   * акаунту (повторний вхід в іншій вкладці), інакше останній власний токен вкладки
   * для її поточного акаунта. Запис читається один раз, тож власник і токен завжди
   * з одного запису.
   */
  token: () => {
    const session = readStoredSession();
    const tab = tabUserKey();

    if (isSessionCurrent(session, tab)) {
      lastOwn = session ? { keyUser: session.keyUser, token: session.token } : null;
      return session ? session.token : null;
    }

    if (lastOwn && lastOwn.keyUser === tab) {
      return lastOwn.token;
    }

    return (store && store.state.authorization && store.state.authorization.token) || null;
  },
};

export default Auth;
